import {
    faChartSimple,
    faGlobe,
    faKey,
    faLayerGroup,
    faListUl,
    faMasksTheater,
    faMusic,
    faRightFromBracket,
    faSackDollar,
    faSliders,
    faWandMagicSparkles
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import appixiLogo from './assets/appixi_logo.png'

// Layout follows rock-dashboard src/components/layout/Sidebar.js (Tabler vertical navbar).
const menuItems = [
    { to: '/portal/dashboard', label: 'Dashboard', icon: faChartSimple },
    { to: '/portal/fairy-ai-list', label: 'Fairy Ai', icon: faWandMagicSparkles },
    { to: '/portal/face-dance-list', label: 'Face Dance', icon: faMusic },
    { to: '/portal/face-swap-list', label: 'Face Swap', icon: faMasksTheater },
    { to: '/portal/category-list', label: 'Category', icon: faLayerGroup },
    { to: '/portal/config-list', label: 'Config', icon: faSliders },
    { to: '/portal/monetization-global', label: 'Monetization Global', icon: faSackDollar },
    { to: '/portal/monetization-list', label: 'Monetization List', icon: faListUl },
    { to: '/portal/service-key-list', label: 'Service Key', icon: faKey },
    { to: '/portal/domains', label: 'Domains', icon: faGlobe }
];

export const logout = (navigate) => {
    localStorage.removeItem('token');
    navigate('/');
};

function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    // On phones the menu starts collapsed and opens from the toggler
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <>
            <aside className={`navbar navbar-vertical navbar-expand-lg ${open ? 'show' : ''}`}>
                <div className="container-fluid">
                    <button
                        className="navbar-toggler"
                        type="button"
                        aria-label="Toggle navigation"
                        onClick={() => setOpen((value) => !value)}
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                    <h1 className="navbar-brand navbar-brand-autodark mb-0">
                        <NavLink className="d-flex align-items-center gap-2 text-decoration-none" to="/portal/dashboard">
                            <img src={appixiLogo} alt="" className="sidebar-brand-logo flex-shrink-0" />
                            <span>Appixi Admin</span>
                        </NavLink>
                    </h1>

                    <div className={`collapse navbar-collapse ${open ? 'show' : ''}`}>
                        <ul className="navbar-nav pt-lg-3">
                            {menuItems.map((item) => (
                                <li className="nav-item" key={item.to}>
                                    <NavLink
                                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                        to={item.to}
                                    >
                                        <span className="nav-link-icon d-md-none d-lg-inline-block">
                                            <FontAwesomeIcon icon={item.icon} fixedWidth />
                                        </span>
                                        <span className="nav-link-title">{item.label}</span>
                                    </NavLink>
                                </li>
                            ))}

                            <li className="nav-item mt-auto">
                                <button
                                    className="nav-link btn btn-link w-100 text-start"
                                    type="button"
                                    onClick={() => logout(navigate)}
                                >
                                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                                        <FontAwesomeIcon icon={faRightFromBracket} fixedWidth />
                                    </span>
                                    <span className="nav-link-title">Logout</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>
            {open ? <div className="sidebar-backdrop" onClick={() => setOpen(false)} /> : null}
        </>
    )
}

export default Sidebar
